import supabase from "artifact/supabase";
import Form, { style } from "element/form";
import connected from "standard/connected";
import define from "standard/define";
import filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";

@define("m-sign-up")
class SignUp extends Form {
  @connected
  @paint
  [trait.template]() {
    return `
      <form class='${style.form}' novalidate>
        <m-name class='${style.form__input}'></m-name>
        <m-email class='${style.form__input}'></m-email>
        <m-password class='${style.form__input}'></m-password>
        <button class='${style.form__button}'>Começar</button>
      </form>
    `;
  }

  @on.submit("form")
  @filter.prevent
  @filter.validity
  @filter.formData
  async [trait.onSubmit]({ email, name, password }) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: { data: { name } },
    });

    error
      ? alert(error.message)
      : location.assign(`/dashboard/${data.user.id}`);

    return this;
  }
}

export default SignUp;
